import AdminSchoolProfile from './AdminSchoolProfile';
export default AdminSchoolProfile;
